const SIZE = {
  sm: "sm",
  md: "md",
  lg: "lg",
  xl: "xl",
};

const CONTAINER_WIDTH = {
  [SIZE.sm]: "w-48",
  [SIZE.md]: "w-64",
  [SIZE.lg]: "w-80",
  [SIZE.xl]: "w-96",
};

export const TooltipContent = ({ title, text, size = SIZE.md }) => {
  return (
    <div
      className={`flex flex-col gap-1 p-1 text-left ${CONTAINER_WIDTH[size]} wrap whitespace-normal normal-case`}
    >
      <h3 className="font-bold">{title}</h3>
      <p>{text}</p>
    </div>
  );
};
